import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		main: {
			// /?safe&mock-data&utm_source=FB&country=US&area=main&exp=web_main_younger_age_groups~1
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_main_younger_age_groups'
					),
			},
		},
	},
]

export default config
